import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userGetCurrent } from '@uncinc/react-drupal-core';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import { fetchMessages } from '../../store/actions/Messages';
import { fetchClients } from '../../store/actions/NursePractitioner';
import { getRegistrationData } from '../../store/actions/Registrations';
import useCrisisAlerts from '../../hooks/useCrisisAlerts';

import {
  DOMAIN_JELLINEK_ZELFHULP,
  DOMAIN_MENTAAL_BALANS,
  DOMAIN_ZELFHULP_BEGELEID,
  DOMAIN_ZELFHULP_NAASTEN,
} from '../../config/constants';

const UserProfileContainer = ({ children }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.getIn(['login', 'loggedIn'], null));

  const currentDomain = useSelector(
    (state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], ''),
  );

  useCrisisAlerts();

  useEffect(() => {
    if (isLoggedIn) {
      switch (currentDomain) {
        case DOMAIN_JELLINEK_ZELFHULP:
          break;

        case DOMAIN_ZELFHULP_BEGELEID: {
          dispatch(fetchClients()).catch(console.error);
          break;
        }

        case DOMAIN_ZELFHULP_NAASTEN:
        case DOMAIN_MENTAAL_BALANS: {
          dispatch(viewGet('exercise_answers', 'default', 0, null, {}));
          dispatch(fetchMessages());
          break;
        }

        default: {
          dispatch(viewGet('exercise_answers', 'default', 0, null, {}));
          dispatch(fetchMessages());
          dispatch(getRegistrationData());
        }
      }
    } else if (isLoggedIn === null) {
      dispatch(userGetCurrent());
    }
  }, [isLoggedIn]);

  return (
    <>{ children }</>
  );
};

export default UserProfileContainer;
